import {Station} from "../../stations/station.service.interface";
import {NullableDate, NullableNumber} from "../../../types/nullable-types";
import {IPassengerTypeSelectorsList} from "../../passenger-types/passengers-types.service.interface";
import {IFlightScheduleFilter} from "../flights-schedule/flight-schedule-filter.interface";

export enum SpecialPriceMarketUserOptions {
    None,
    Regular,
    Season
}

export enum SpecialPriceMarketUserAgreement {
    None,
    Agree,
    DontAgree
}

export interface IFlightSearchParams {
    readonly isOneWayDepartureTrip: boolean;
    readonly isOneWayReturnTrip: boolean;
    readonly departureOrigin: Station;
    readonly departureDestination: Station;
    readonly specialPriceMarketUserOption: SpecialPriceMarketUserOptions;
    readonly specialPriceMarketUserAgreement: SpecialPriceMarketUserAgreement;
    readonly returnOrigin: Station;
    readonly returnDestination: Station;
    readonly departureDate: Date;
    readonly returnDate: NullableDate;
    readonly passengers: IPassengerTypeSelectorsList;
    readonly withBlueBenefits: boolean;
    readonly departureClassOfServices: string[];
    readonly returnClassOfServices: string[];
    readonly departureMinPrice: NullableNumber;
    readonly returnMinPrice: NullableNumber;
    readonly allowBogo: boolean;
    readonly departureFlightScheduleFilter: IFlightScheduleFilter | null;
    readonly returnFlightScheduleFilter: IFlightScheduleFilter | null;
}
